import { useState } from 'react';
import { GOAL_STEPS, WEIGHT_UNIT } from '../../../types/enum';
import EndGoal from './endGoal';
import DailyWorkout from './dailyWorkout';
import DailyCalorie from './dailyCalorie';
import DailyPCF from './dailyPCF';
import Summary from './summary';

const Goal = ({ userDetail, weightUnit }) => {
  const [currentStep, setCurrentStep] = useState(GOAL_STEPS.END_GOAL);
  const [goals, setGoals] = useState({
    workoutHours: '0 mins',
    workoutDays: '0 days',
    weight: userDetail.weight,
  });

  return (
    <div className='w-full max-w-sm mx-auto'>
      {currentStep === GOAL_STEPS.END_GOAL && (
        <EndGoal
          goals={goals}
          setGoals={setGoals}
          setCurrentStep={setCurrentStep}
          weightUnit={weightUnit}
        />
      )}
      {currentStep === GOAL_STEPS.DAILY_WORKOUT && (
        <DailyWorkout
          goals={goals}
          setGoals={setGoals}
          setCurrentStep={setCurrentStep}
        />
      )}
      {currentStep === GOAL_STEPS.DAILY_CALORIE && (
        <DailyCalorie
          goals={goals}
          setGoals={setGoals}
          setCurrentStep={setCurrentStep}
          userDetail={userDetail}
          weightUnit={weightUnit}
        />
      )}
      {currentStep === GOAL_STEPS.DAILY_PCF && (
        <DailyPCF
          setGoals={setGoals}
          setCurrentStep={setCurrentStep}
        />
      )}
      {currentStep === GOAL_STEPS.SUMMARY && (
        <Summary
          goals={goals}
          setGoals={setGoals}
          setCurrentStep={setCurrentStep}
          userDetail={userDetail}
          weightUnit={weightUnit}
        />
      )}
    </div>
  );
};

export default Goal;
